import { EpisodeDetails, EpisodeVersionDetails, TvSeasonDetails } from "../../../TvSeriesDetails";

export interface SeasonListingItem {
    id: string;
    name: string;
    number: number;
    orphaned: boolean;
    isModified?: boolean;
    merged?: boolean;
    buzzId?: string;
    orphanedDetails: string[];
}

export const mapToSeasonListingItem = (season: TvSeasonDetails, isModified?: boolean): SeasonListingItem => {
    return {
        id: season.id,
        name: season.name,
        orphaned: seasonOrphaned(season),
        isModified,
        merged: !!season.mergedTargetId,
        buzzId: season.buzzId,
        number: season.number,
        orphanedDetails: getTvSeasonOrphanedDetails(season)
    };
};

const seasonOrphaned = (season: TvSeasonDetails) => {
    return !season.buzzId || season.episodes.some((episode: EpisodeDetails) => episodeOrphaned(episode));
};

const episodeOrphaned = (episode: EpisodeDetails, orphanedVersionsCount?: number) => {
    if (orphanedVersionsCount) {
        return (!episode.buzz?.id || orphanedVersionsCount > 0) && !episode.mergedTargetId;
    }

    return (
        !episode.buzz?.id ||
        episode.versions.some((version: EpisodeVersionDetails) => !version.buzzVersion?.id && !version.mergedTargetId)
    );
};

const getTvSeasonOrphanedDetails = (tvSeason?: TvSeasonDetails): string[] => {
    if (!tvSeason) {
        return ["Season is orphaned"];
    }

    const messages: string[] = [];
    const seasonOrphanedInfo = getSeasonOrphanedInfo(tvSeason);

    if (seasonOrphanedInfo.orphaned) {
        messages.push("Season is orphaned");
    }

    if (seasonOrphanedInfo.orphanedEpisodesCount > 0) {
        messages.push(`Orphaned episodes count: ${seasonOrphanedInfo.orphanedEpisodesCount}`);
    }

    if (seasonOrphanedInfo.orphanedEpsiodeVersionsCount > 0) {
        messages.push(`Orphaned versions count: ${seasonOrphanedInfo.orphanedEpsiodeVersionsCount}`);
    }

    return messages;
};

const getSeasonOrphanedInfo = (season: TvSeasonDetails) => {
    const episodeOrphanedInfo = getEpisodesOrphanedInfo(season.episodes);
    const orphaned = !season.buzzId || episodeOrphanedInfo.orphanedEpisodesCount > 0;

    return {
        ...episodeOrphanedInfo,
        orphaned
    };
};

const getEpisodesOrphanedInfo = (episodes: EpisodeDetails[]) => {
    let orphanedEpsiodeVersionsCount = 0;
    const orphanedEpisodes: EpisodeDetails[] = [];

    episodes.forEach((episode: EpisodeDetails) => {
        const orphanedVersionsCount = getEpisodeVersionsOrphanedCount(episode.versions);
        orphanedEpsiodeVersionsCount += orphanedVersionsCount;

        if (episodeOrphaned(episode, orphanedVersionsCount)) {
            orphanedEpisodes.push(episode);
        }
    });

    const orphanedEpisodesCount = orphanedEpisodes.length;

    return { orphanedEpsiodeVersionsCount, orphanedEpisodesCount };
};

const getEpisodeVersionsOrphanedCount = (episodeVersions: EpisodeVersionDetails[]): number => {
    const orphanedVersions = episodeVersions.filter(
        (version: EpisodeVersionDetails) => !version.buzzVersion && !version.mergedTargetId
    );

    return orphanedVersions.length;
};
